import {
  DoorsDefinition,
  DOORS,
  QUIZ_DOOR,
  QuizDoorDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Interactive32: Translator = sequence => {
  const doors: QuizDoorDefinition[] = [];
  const header: { title?: string[]; subtitle?: string; icon?: string } = {
    title: [],
    subtitle: '',
    icon: ''
  };

  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      item?.items?.map((subItem, i) => {
        doors.push({
          type: QUIZ_DOOR,
          id: subItem.id,
          values: {
            id: subItem.id,
            groupId: item.id,
            name: subItem.value!,
            correct: subItem.correct!,
            imageUrl: item.pictures![i].mediaUrl!
          },
          items: []
        });
        header.title = item?.body
          ?.replace('<p>', '')
          ?.replace('</p>\n', '')
          ?.split(' ');
        header.subtitle = item.subtitle!;
        header.icon = item.icon!;
      });
    }

    return null;
  });

  root.items.push({
    type: DOORS,
    id: `${sequence.id}.carousel`,
    items: doors,
    values: {
      header: header
    }
  } as DoorsDefinition);

  return root;
};
